export const Projects = [
  {
    title: "ALADDIN365",
    languages: "Next.js, Tailwind CSS, Node js, SQL",
    url: "https://aladdin365.com",
    description:
      "A social media networking platform for the textile industry, similar to LinkedIn, featuring groups, company pages, the ability to follow and connect with others, job postings, and a feed for sharing posts.",
    bgImage: "./assets/images/projects/aladdin.jpeg",
  },
  {
    title: "WHEELIYO",
    languages: "Next.js, Tailwind CSS, Node js, MongoDB",
    url: "https://wheeliyo.com",
    description:
      "This app is a comprehensive platform designed to connect buyers and sellers of pre-owned vehicles, including cars listed through bank auctions. Advanced filters for users to search by make, model, year, price range, location, mileage, and more. Detailed car profiles with photos, vehicle history, specifications, and seller information. Notifications and reminders for upcoming auctions. Users can save car listings to a personalized 'Saved List' for quick access and comparison. Secure payment gateways for seamless online transactions. Premium plans offer additional benefits.",
    bgImage: "./assets/images/projects/wheeliyo.jpeg",
  },
  {
    title: "JOBSINC",
    languages: "Next.js, Tailwind CSS, Node js, MongoDB",
    url: "https://jobsinc.ae",
    description:
      "This project aims to develop a job listing platform that offers advanced features like network optimization, CV writing services, and consultancy support to job seekers. The platform aggregates job listings from sources such as LinkedIn and Indeed, providing users with a comprehensive job search experience. Additionally, the app offers a payment gateway for accessing premium features, enhancing user interaction and increasing job placement success.",
    bgImage: "./assets/images/projects/jobsinc.jpeg",
  },
  {
    title: "TEXCOMSWORLDWIDE",
    languages: "Next.js, Tailwind CSS, REST API",
    url: "https://www.texcoms.com",
    description:
      "This web application is an auction platform specifically designed for listing textile machinery. The website features advanced filtering options that allow users to narrow their search based on machine category, department, make... ensuring a seamless and efficient browsing experience. Each listing provides detailed views of the machinery, including images, specifications. The platform is fully mobile-responsive, offering an optimized user experience across all devices.",
    bgImage: "./assets/images/projects/texcoms.jpg",
  },
  {
    title: "EVENTIVE",
    languages: "React js, Node js, MongoDB, Express js",
    url: "https://github.com/suhail-kk/eventive",
    description:
      "An all-in-one event management app designed for college fine arts and sports events. Students can create accounts, browse, and register for events, while admins can set up event schedules, manage registrations, assign points, and track participation—all in a single, streamlined platform.",
    bgImage: "./assets/images/projects/eventive.jpg",
  },
  {
    title: "STUDENT MANAGEMENT APP",
    languages: "Andriod java",
    url: "https://github.com/suhail-kk/connectemea",
    description:
      "The College Student Information Management App (CSIMA) is a mobile application built to simplify and digitize the management of student information within a college or institute. This app enables the college administration, faculty, and students to access essential student records and manage academic-related information",
    bgImage: "./assets/images/projects/student.jpg",
  },
  {
    title: "STUDY ABROAD CRM",
    languages: "Next.js, Styled-components",
    url: "Stay connected...",
    description:
      "A comprehensive CRM tailored for managing study abroad and visa processing. This system streamlines applicant tracking, document management, communication, and visa status updates, offering a seamless experience for both consultants and students pursuing international education opportunities.",
    bgImage: "./assets/images/projects/a4u.jpg",
  },
  {
    title: "CREATIVE PROJECT MANAGEMENT CRM",
    languages: "Next.js, Tailwind CSS",
    url: "",
    description:
      "A specialized project management CRM for design professionals, enabling seamless collaboration between clients, designers, and managers. Users can create bids, assign roles (admin, designer, project manager, client), and track progress, making it easy to manage design projects from proposal to completion.",
    bgImage: "./assets/images/projects/freelance.jpg",
  },
  {
    title: "Affiliate marketing",
    languages: "Next.js, Tailwind",
    url: "",
    description:
      "A CRM application designed for brands and promoters, where brands can create campaigns to boost visibility, and promoters can share campaign details to expand reach. The system tracks clicks and conversions, providing insights into promotion effectiveness and engagement.",
    bgImage: "./assets/images/projects/affiliate.jpg",
  },
  {
    title: "CAREER MANAGEMENT SYSTEM",
    languages: "Next.js, Tailwind CSS",
    url: "",
    description:
      "The Job Posting and Applicant Management System is a streamlined web application designed specifically for organizations to manage their recruitment process efficiently. Administrators can easily create and publish job listings with detailed descriptions, requirements, and application deadlines. Job seekers can browse available positions and submit their applications directly through the platform.",
    bgImage: "./assets/images/projects/job_portal.jpg",
  },
  {
    title: "COMMUNITY MANAGEMENT REGISTRATION SYSTEM",
    languages: "Next.js, Tailwind CSS",
    url: "",
    description:
      "The Community Membership Registration System (CMRS) is a web-based application aimed at facilitating the registration and management of members within a community organization. This application streamlines the registration process, enabling users to submit their details, make payments, and receive their membership ID cards electronically. By integrating user-friendly features and secure payment gateways, CMRS enhances the overall experience for both administrators and members.",
    bgImage: "./assets/images/projects/registration.jpg",
  },
];
